import  { apiConfig } from "../helpers";
import { authHeader } from '../helpers';
import axios from 'axios';

export const icdService = {
    getAll,
    getAllICD9MainCategories,
    getSubSections,
    GetSubCategories,
    GetDetailedCategories,
    GetTherapistICD9Categories,
    GetFullSearchICD9
};

function getAll(data)
{
    return axios.get('/api/services/app/ICD/GetAll', {
        params: {
            SearchTerm: data.query,
            SkipCount: (data.page-1) * data.limit,
            MaxResultCount: data.limit
        },
        baseURL: apiConfig.apiUrl,
        headers: authHeader()
    })
}
function getAllICD9MainCategories()
{
    return axios.get('/api/services/app/ICD/GetAllICD9MainCategories', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader()
    })
}
function getSubSections(mainCategory)
{
    return axios.get('/api/services/app/ICD/GetSubsections', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            mainCategory: mainCategory
        }
    })
}
function GetSubCategories(subsection)
{
    return axios.get('/api/services/app/ICD/GetAllICD9SubCategories', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            subsection: subsection
        }
    })
}
function GetDetailedCategories(subCategory)
{
    return axios.get('/api/services/app/ICD/GetAllICD9DetailedCategories', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            subCategory: subCategory
        }
    })
}
function GetTherapistICD9Categories(visitId)
{
    return axios.get('/api/services/app/ICD/GetTherapistICD9DefaultMainCategories', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            visitId: visitId
        }
    })
}
function GetFullSearchICD9(term)
{
    return axios.get('/api/services/app/ICD/GetFullSearchICD9', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            term: term
        }
    })
}